module.exports = __webpack_public_path__ + "img/message-text.b386211e.svg";